export default function deprecate({ name, value, message }) {
  if (value && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(`\`${name}\` has been deprecated.`, message)
  }
}
